<router-outlet /> <app-progress-spinner />
